package com.klantenstop.web.components.dialogs.manageCompanyReview

import com.klantenstop.web.data.models.domain.Review
import com.klantenstop.web.utils.MVI

interface ManageCompanyReviewContract : MVI<ManageCompanyReviewContract.State, ManageCompanyReviewContract.Intent, ManageCompanyReviewContract.Effect> {

    companion object {
        const val REVIEW_MAX_LENGTH = 1000
    }

    data class State(
        val originalReview: Review? = null,
        val rating: Int = 0,
        val reviewText: String = "",
        val hasAttemptedSave: Boolean = false,
    ) {
        private val ratingChanged = rating != originalReview?.rating
        private val reviewTextChanged = reviewText != originalReview?.text

        val hasChanged: Boolean = ratingChanged || reviewTextChanged

        val isRatingValid: Boolean get() = rating in 1..5
        val isReviewTextValid: Boolean get() = reviewText.isNotBlank() && reviewText.length <= REVIEW_MAX_LENGTH
        val isFormValid: Boolean get() = isRatingValid && isReviewTextValid
    }

    sealed class Intent {
        data class UpdateReviewRating(val rating: Int) : Intent()
        data class UpdateReviewText(val reviewText: String) : Intent()
        data object SaveCompanyReview : Intent()
    }

    sealed class Effect {
        data class SaveCompanyReview(val rating: Int, val reviewText: String) : Effect()
    }
}
